export class Location {
  static get fullFormat() {
    return 'dddd h:mm a.';
  }

  static get orderedDayMap() {
    return [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
  }

  /* istanbul ignore next - No need to test moment */
  static get easternTime() {
    moment.tz.add([
      'America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6',
    ]);

    return moment.tz('America/New_York');
  }

  /* istanbul ignore next - No need to test moment */

  static get centralTime() {
    moment.tz.add([
      'America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0',
    ]);

    return moment.tz('America/Chicago');
  }

  /* istanbul ignore next - No need to test moment */

  static get localTime() {
    return moment();
  }

  static isOpen(location) {
    const nowInCentralTime = Location.centralTime;
    const currentDay = nowInCentralTime.day();
    const schedule = location[Location.orderedDayMap[currentDay]];
    if (!schedule) {
      return false;
    }
    const open = Location.getScheduleTime(currentDay, schedule.from);
    const close = Location.getScheduleTime(currentDay, schedule.to);

    return nowInCentralTime.isBetween(open, close) || open.isSame(close);
  }

  static getScheduleTime(day, seconds) {
    return Location.centralTime.day(day).startOf('day').add(seconds, 'second');
  }

  static getScheduleLocalTime(day, seconds) {
    return Location.getScheduleTime(day, seconds).utcOffset(
      Location.localTime.utcOffset()
    );
  }

  static getNearestDayWithOpening(location, fromDay) {
    let nextDayWithOpening = fromDay;
    for (let i = 0; i < 7; i++) {
      if (
        location[Location.orderedDayMap[nextDayWithOpening]] &&
        location[Location.orderedDayMap[nextDayWithOpening]].from
      ) {
        return nextDayWithOpening;
      }
      if (nextDayWithOpening < 6) {
        nextDayWithOpening++;
      } else {
        nextDayWithOpening = 0;
      }
    }
    return -1;
  }

  /**
   * Checks if there is any comment in the location array.
   */
  static getFirstComment(location) {
    let result = '';
    Object.values(location).forEach((val) => {
      if (!result && val.comment) {
        result = val.comment;
      }
    });
    return result;
  }

  /**
   * Cases:
   *   - Location is open on current day
   *     - and location is open 24h for current day
   *       - and next close time is at *next day* closing time
   *     - and current time is < open time
   *       - and next open time is today at open time
   *     - and current time is > close time
   *       - and next open time is on next open day at next open day's open time
   *     - and current time is between open and close time
   *       - and location closes at close time
   *   - Location is closed on current day
   *     - and next open time is on next open day at next open day's open time
   *   - Location has no schedule information
   * @param location
   * @returns {string}
   */
  static renderCurrentDaySchedule(location, openText) {
    const template = (vars) =>
      `<div class="current">${vars.open}<span class="message">${vars.message}</div>`;
    const nowInCentralTime = Location.centralTime;
    const nowInLocalTime = Location.localTime;
    const currentDay = nowInCentralTime.day();
    let nextOpenDay = Location.getNearestDayWithOpening(location, currentDay);
    let firstMessage = Location.getFirstComment(location);
    // Show default text if there is not any comment in the location object.
    if (nextOpenDay === -1) {
      if (!firstMessage) {
        return template({
          open: '<span class="closed">Varies by provider</span>',
          message: ``,
        });
      }
      return template({
        open: '<h3>Hours</h3>',
        message: '',
      });
    }
    if (nextOpenDay !== currentDay) {
      const scheduleForToday = location[Location.orderedDayMap[currentDay]];
      if (!scheduleForToday) {
        return template({
          open: '<h3>Hours</h3>',
          message: '',
        });
      }

      if (!scheduleForToday.from && scheduleForToday.comment) {
        return template({
          open: '',
          message: scheduleForToday.comment,
        });
      }
      let nextOpen = nowInCentralTime.clone();
      nextOpen.startOf('day');
      nextOpen.add(
        nextOpenDay < currentDay
          ? 7 - currentDay + nextOpenDay
          : nextOpenDay - currentDay,
        'day'
      );
      nextOpen.add(
        location[Location.orderedDayMap[nextOpenDay]].from,
        'second'
      );
      nextOpen.utcOffset(nowInLocalTime.utcOffset());
      return template({
        open: '<span class="closed">Closed, </span>',
        message: `Opens ${Location.formatTime(nextOpen, true)}`,
      });
    } else {
      const scheduleForDay = location[Location.orderedDayMap[nextOpenDay]];
      if (scheduleForDay && !scheduleForDay.from && scheduleForDay.comment) {
        return template({
          open: '',
          message: scheduleForDay.comment,
        });
      }
      if (scheduleForDay.from === scheduleForDay.to) {
        return template({
          open: '<span class="open">Open</span>',
          message: `24 Hours`,
        });
      }
      const open = nowInCentralTime
        .clone()
        .startOf('day')
        .add(scheduleForDay.from, 'second');
      const close = nowInCentralTime
        .clone()
        .startOf('day')
        .add(scheduleForDay.to, 'second');

      if (nowInCentralTime.isBetween(open, close)) {
        const closesAt = close.clone().utcOffset(nowInLocalTime.utcOffset());
        return template({
          open: '<span class="open">' + openText + '</span>',
          message: ``,
        });
      } else if (nowInCentralTime.isBefore(open)) {
        const openAt = open.clone().utcOffset(nowInLocalTime.utcOffset());
        return template({
          open: '<span class="closed">Closed, </span>',
          message: `Opens ${Location.formatTime(openAt, true)}`,
        });
      } else if (nowInCentralTime.isAfter(close)) {
        nextOpenDay = Location.getNearestDayWithOpening(
          location,
          nextOpenDay < 6 ? nextOpenDay + 1 : 0
        );
        const nextOpen = nowInCentralTime
          .clone()
          .startOf('day')
          .add(
            nextOpenDay < currentDay
              ? 7 - currentDay + nextOpenDay
              : nextOpenDay - currentDay,
            'day'
          )
          .add(location[Location.orderedDayMap[nextOpenDay]].from, 'second')
          .utcOffset(nowInLocalTime.utcOffset());
        return template({
          open: '<span class="closed">Closed, </span>',
          message: `Opens ${Location.formatTime(nextOpen, true)}`,
        });
      } else {
        throw "Shouldn't get here.";
      }
    }
  }

  static formatTime(time, full = false) {
    let meridiem = 'a.m.';
    let format = '';
    if (full) {
      format = 'dddd ';
    }
    format += 'h';
    if (time.hours() > 11) {
      meridiem = 'p.m.';
    }
    if (time.minutes() > 0) {
      format += ':mm';
    }
    return `${time.format(format)} ${meridiem}`;
  }

  static alterHoursMatrix() {
    // Alter the hours matrix to match local time.
    let selectors = $('span.office-hours__item-slots', document);
    if (selectors.length) {
      selectors.each(function () {
        let element = $(this);
        let text = element.text();
        text = text.replaceAll('.', '');
        let hours = text
          .split('-')
          .filter((item) => item.length > 0)
          .map(function (item) {
            return item.trim();
          });
        let newHours = [];
        hours.forEach(function (value) {
          let today = Location.centralTime;
          today.startOf('day');
          today.add(value, 'h');
          let local = today.local();
          local = Location.formatTime(local);
          newHours.push(local);
        });
        if (newHours.length > 0) {
          element.text(newHours.join(' - '));
        }
      });
    }
  }
}
